module.exports = __webpack_public_path__ + "img/rease_logo.6cf4e8f8.png";